import { render } from "./CreateAutoPassLimit.vue?vue&type=template&id=30c0996a"
import script from "./CreateAutoPassLimit.vue?vue&type=script&lang=js"
export * from "./CreateAutoPassLimit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__